import createTableStore from "ds/components/Table/store/useTableStore";

import {
  MODULE_WEBHOOKS_TABLE_COLUMNS_CONFIG,
  MODULE_WEBHOOKS_TABLE_STORAGE_KEY,
} from "./constants";

const useModuleWebhooksTableStore = createTableStore({
  storageKey: MODULE_WEBHOOKS_TABLE_STORAGE_KEY,
  config: MODULE_WEBHOOKS_TABLE_COLUMNS_CONFIG,
});

export default useModuleWebhooksTableStore;
